//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { DaySelectionDisplayItem } from './DaySelectionDisplayItem';
import { RepeatFrequencyEnum, RepeatMonthTypeEnum } from './Enums';

export class RepeatDetailsItem extends ItemBase {
    DaySelection: DaySelectionDisplayItem | null = null;
    EndDate: string | null = null;
    Frequency: RepeatFrequencyEnum = RepeatFrequencyEnum.Daily;
    Interval: number = 0;
    MonthType: RepeatMonthTypeEnum = RepeatMonthTypeEnum.Absolute;

    constructor(initializer?: Partial<RepeatDetailsItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepeatDetailsItem";
}
